import {currentUserMeetsUserLevel, getPreference} from '@netx/core-user/utils';
import {
	ConstituentsPref,
	SEARCH_CONSTITIUENT_CLIPS_MINIMUM_USER_LEVEL,
} from './constants';

export const consituentClipsEnabled = () =>
	getPreference(ConstituentsPref.CLIPS_ENABLED, true);

export const canSearchConstituentClips = () =>
	consituentClipsEnabled() &&
	currentUserMeetsUserLevel(SEARCH_CONSTITIUENT_CLIPS_MINIMUM_USER_LEVEL);
